import { useQuery } from "@tanstack/react-query";
import { getProjects } from "../../api/project";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

export const useProjects = () => {
    const [query, setQuery] = useState({
        search: "",
        status: true,
        page: 1,
        limit: -1,
    })

    const { data: projects, isLoading, refetch } = useQuery({
        queryKey: ["projects"],
        queryFn: () => {
            try {
                return getProjects(query);
            } catch (error) {
                console.log(error);
                return [];
            }
        }
    })

    useEffect(() => {
        refetch();
    }, [query, refetch]);

    const handleSetQuery = (newQuery: {
        search?: string;
        status?: boolean;
        page?: number;
        limit?: number;
    }) => {
        setQuery({ ...query, ...newQuery });
    }

    const schema = yup.object().shape({
        search: yup.string().optional(),
        status: yup.boolean().optional(),
    })

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    })

    const onSubmit = (data: any) => {
        handleSetQuery({
            search: data.search,
        });
    }

    return {
        projects,
        isLoading,
        refetch,
        handleSetQuery,
        register,
        handleSubmit,
        errors,
        onSubmit
    };
}